<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer082">
<p class="structure-next" id="calibre_pb_13"><img alt="" class="_idgenobjectattribute1" src="OEBPS/image/Image_1_Human_Dance.png"/></p>
<div class="calibre1" id="calibre_pb_14"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// GladtoBeHuman_split_006.vue?ce737818